// import Layout from '@/page/layout/home'
import LayoutNoFooter from '@/page/layout/index'

export default [
    {
        path: '/notification',
        name: 'notification',
        component: LayoutNoFooter,
        children: [
            {
                path: 'index',
                name: 'notificationIndex',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/notification/index'),
                meta: {
                    title: '通知管理',
                    isAuth: true
                }
            }
        ]
    },
]


